/* eslint-disable */
import { buttonSmall } from "../../../shared/styles";
import globalState from "../../../store";
import { useAtom } from "jotai";
import {
  IService,
  IServicePackage,
  IServiceProduct,
} from "../../../types/types";
import { v4 as uuidv4 } from "uuid";

interface AddServiceProductButtonProps {
  service: IService;
  servicePackageId: number | string;
  // eslint-disable-next-line
  setActiveService: React.Dispatch<React.SetStateAction<any>>;
}

const AddServiceProductButton: React.FC<AddServiceProductButtonProps> = ({
  service,
  servicePackageId,
  setActiveService,
}) => {
  const [globalStateAtom, setGlobalState] = useAtom(globalState);

  const blankServiceProductObject: IServiceProduct = {
    name: "",
    service_package_id: servicePackageId,
    price: "",
    id: uuidv4(),
    description: "",
  };

  const addNewFooter = () => {
    const newServicePackages = service.packages;
    newServicePackages.map((servicePackage: IServicePackage) => {
      if (servicePackage.id === servicePackageId) {
        servicePackage.service_products.push(blankServiceProductObject);
      }
      return servicePackage;
    });

    const newService = { ...service, packages: newServicePackages };

    setGlobalState({
      ...globalStateAtom,
      services: globalStateAtom.services.map((s: IService) =>
        s.order === service.order ? newService : s
      ),
    });

    // Should get rid of this pattern
    setActiveService(newService);
  };

  return (
    <button onClick={addNewFooter} className={`${buttonSmall} relative`}>
      Add Service Product
    </button>
  );
};

export default AddServiceProductButton;
